import React, { useState, useEffect, useRef } from 'react';
import { basic, timeoutMilliseconds, validationMessages, wholeNumber } from '../../../config/validations';
import { Controller, useForm } from "react-hook-form";
import { Checkbox, FormControl, FormControlLabel, FormLabel, Grid, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import UpdateCancel from '../../atoms/buttons/UpdateCancel';
import { toggleRightDrawer, setDisablePan, setFocusElement } from '../../../store/global/actions';
import { getConstructType } from '../../../config/common';
import { getElementOnFocus, getRightDrawerStatus } from '../../../store/global/selectors';
import { invokePostService, invokeGetService, setReRender, setInnerScreenRender, setHeaderName, handleSnackBar, setDisabled } from "../../../store/global/actions";
import { useParams } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import SkeletonLoader from '../../atoms/loader/SkeletonLoader';
import { generateMongoId } from '../../../utils/commonUtils';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { UtilityFunctionDialog } from '../utility_functions/UtilityFunctionDialog';

export default function AdvancedSetup({ onCompletion, element }) {
    const category = useRef('');
    const params = useParams();
    const currentUrl = window.location.href;
    const history = useHistory();
    const [slug, blueprintID] = currentUrl.split('/').slice(4);
    const filter = createFilterOptions();

    const dispatch = useDispatch();
    const elementOnFocus = useSelector(getElementOnFocus);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);


    const [transaction, setTransaction] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isOptional, setOptional] = useState(false);
    const [isContinueTimeout, setContinueTimeout] = useState(false);
    const [isScatterInst, setScatterInst] = useState(false)
    const [showChildTypeSelection, setShowChildTypeSelection] = useState(false);
    const [utilityFunctions, setUtilityFunctions] = useState([]);
    const [onErrorValue, setOnErrorValue] = useState(null);
    const [openUtilityFunctionDialog, setOpenUtilityFunctionDialog] = useState(false);
    const [selectedUtilityFunction, setSelectedUtilityFunction] = useState(null);


    const { register, handleSubmit, formState: { errors }, clearErrors, setValue, reset, control, setError } = useForm({
        defaultValues: {
            name: transaction?.name,
            description: transaction?.description,
            section: transaction?.section,
            version: transaction?.version,
            timeout: transaction?.timeout,
            spec: transaction?.spec,
            optional : transaction?.optional,
        }
    });

    
    useEffect(() => {
        setLoading(true);
        if (element?.id != null) getTransactionAssociates();
    }, [element]);


    const getTransactionAssociates = () => {

        const transactionPromise = dispatch(invokeGetService('getTransactionAssociates', [element.id]));
        const utilitiesPromise = dispatch(invokeGetService('getAllUtilityFunctions', []));


        Promise.all([transactionPromise, utilitiesPromise])
        .then(([transactionResponse, utilitiesResponse]) => {
                setLoading(false);
                let modifiedUtilityFunctions= [];
                if (utilitiesResponse.status && utilitiesResponse.data) {
                    const sortedUtilityFunctions = utilitiesResponse.data?.filter(item => item.name)?.sort((a, b) => a.name.localeCompare(b.name));
                    modifiedUtilityFunctions = sortedUtilityFunctions.map(item => ({ title: item.name, value: item._id.toString() }));
                    setUtilityFunctions(modifiedUtilityFunctions);
                }

                if (transactionResponse.data.transaction !== undefined) {
                    let selectTrans = transactionResponse.data?.transaction;

                    setTransaction(selectTrans);
                    setValue('name', selectTrans?.name)
                    setValue('description', selectTrans?.description)
                    setValue('version', selectTrans?.version)
                    setValue('spec', selectTrans?.spec)
                    setValue('timeout', selectTrans?.timeout)
                    setValue('section', selectTrans?.section)
                    const utilityFuncion = modifiedUtilityFunctions.find(item => item.value === selectTrans?.onerror);
                    setOnErrorValue(utilityFuncion);

                    if (transactionResponse.data.transaction.events.length === 0 && transactionResponse.data.transaction.nestedTransactions.length === 0) {
                        dispatch(setDisabled(true))
                    }else {
                        dispatch(setDisabled(false))
                    }

                    if (getConstructType(element.type) === 'nested_transaction') {
                        if(selectTrans?.events?.length === 0) setShowChildTypeSelection(true);
                        setValue('optional', selectTrans?.optional)
                        setValue('timeout', selectTrans.timeout)
                        setOptional(selectTrans?.optional)
                        setContinueTimeout(selectTrans?.continueontimeout)
                        setScatterInst(selectTrans?.scatter_inst);
                    }

                    if (element.id === elementOnFocus.id && elementOnFocus.category !== undefined) {
                        category.current = elementOnFocus.category;
                    }

                }else if (!transactionResponse?.status  && transactionResponse?.code === 255 && transactionResponse.transactionNotFound === true) {
                    history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                }


            })
    }

    const onCancel = () => {
        dispatch(setDisablePan(false));
        dispatch(toggleRightDrawer());
    }



    const onUpdate = async (data) => {
        setIsEditing(true);
        let updateStatus = false;

        let {spec, version, section, timeout, optional, continueontimeout, scatter_inst, onerror } = data;
        

        let editTransaction = {
            ...transaction
        }

        if (getConstructType(element.type) !== 'nested_transaction') {
            if (spec !== undefined) editTransaction.spec = spec;
            if (section !== undefined) editTransaction.section = section;
            if (version !== undefined) editTransaction.version = version;
            if (timeout !== undefined) editTransaction.timeout = timeout;
            if (onerror !== undefined) editTransaction.onerror = onErrorValue?.value || null;
        }

        if (getConstructType(element.type) === 'nested_transaction') {
            editTransaction.optional = isOptional;
            editTransaction.continueontimeout = isContinueTimeout;
            editTransaction.scatter_inst = isScatterInst;
            editTransaction.timeout = timeout
            
            await dispatch(invokePostService('updateNestedTransaction', { nestedData: editTransaction }, [element.id]))
            .then((response) => {
                
                if (response.status && response.data) {
                    updateStatus = true
                    dispatch(handleSnackBar({ open: true, message: 'Child transaction updated', severity: 'success' }));
                }else if (response?.status === false && response.errors !== undefined && response.errors.length > 0) {
                    if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                        response?.errors?.forEach(error => {
                            setError(error?.name, { message: error.message });
                        });
                    }
                }else{
                    dispatch(handleSnackBar({ open: true, message: response?.message ? response?.message : 'Failed to update the transaction', severity: 'error' }));
                }

                dispatch(setReRender());
                setIsEditing(false)
            })

        }else {
            await dispatch(invokePostService('updateTransactionInfo', { transaction: editTransaction, isAdvancedConfig: true }, [params.transaction]))
                .then((response) => {
                    if (response.status) {
                        updateStatus = true;
                        dispatch(handleSnackBar({ open: true, message: `Transaction updated`, severity: "success" }));
                    } else if (response?.status === false && response?.code === 255 && response.transactionNotFound === true) {
                        updateStatus = false;
                        history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                    }

                    dispatch(setReRender());
                    setIsEditing(false);
                })
        }

        if (process.env.REACT_APP_AUTO_CLOSE === 'true' && rightDrawerStatus) {
            dispatch(toggleRightDrawer());
        }
    }


    const createUtilityFunction = (id, name) => {
        const utilityFunction = {
            _id: id,
            name: name,
            body: "",
            parameters: [{name: "reason"}, {name: "instance"}, {name: "transaction"}, {name: "message"}],
            type: 10,
        };
        setSelectedUtilityFunction(utilityFunction);
        setUtilityFunctions((prev) => [...prev, {title: name, value: id}]);
        dispatch(invokePostService("createUtilityFunction", { utilityFunction }, []))
            .then(response => {
                if (!response.status) {
                    setUtilityFunctions((prev) => prev.filter(item => item.value != id));
                    dispatch(handleSnackBar({ open: true, message: `Utility function creation failed`, severity: "error" }));
                } else {
                    dispatch(setInnerScreenRender());
                }
            });
    }

    const handleCloseUtilityFunctonDialog = () => {
        setOpenUtilityFunctionDialog(false);
      }


      const onerrorValidation = (value, utilityFunctions = []) => {
        if (!value || value.trim() === "") {
            return "Function name is required";
          }
      
          if (!/^[a-zA-Z_]\w*/.test(value)) {
            return "Invalid function name";
          }
      
          const fnName = value.split("(")[0].trim();
          if (utilityFunctions.some((f) => f.name === fnName)) {
            return "Function name already exists";
          }
            
          return true; 
    };

    const handleCreateFunction = (inputValue) => {
        const validation = onerrorValidation(inputValue, utilityFunctions);
        if (validation !== true) {
            setError("onerror", {message: validation});
            return;
        } else {
            clearErrors("onerror");
        }
        const id = generateMongoId();
        createUtilityFunction(id, inputValue);
        setOnErrorValue({
            title: inputValue,
            value: id
        });
        setOpenUtilityFunctionDialog(true);
    }


    return (
        <>
            {isLoading && 
                <SkeletonLoader rows={5}/>
            }

            {!isLoading &&
            <Grid id={"transaction_advanced_setup"} container direction={"row"} spacing={3} style={{paddingTop: 10,}}>

                {getConstructType(element.type) === 'nested_transaction' && 
                <Grid item xs={12}>
                    <TextField
                        name="timeout"
                        fullWidth
                        type={"text"}
                        label={"Timeout"}
                        variant="outlined"
                        placeholder={"In milliseconds"}
                        error={errors?.timeout ? true : false}
                        inputRef={register({...wholeNumber})}
                        helperText={errors?.timeout && errors?.timeout?.message ? errors.timeout.message : ''}
                    />
                </Grid>}

                {getConstructType(element.type) === 'nested_transaction' && 
                <Grid item xs={12}>
                    {/* <Controller
                        name="optional"
                        control={control}
                        render={({ field, onChange, value }) =>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        {...field}
                                        onChange={e => {
                                            onChange(e.target.checked)
                                            setOptional(e.target.checked)
                                        }}
                                        name="optional"
                                        id="optional"
                                        color="primary"
                                        value={value}
                                        checked={value}
                                    />
                                }
                                label="Optional"
                            />
                        }
                    /> */}
                    <FormControlLabel className="autoFill"
                        control={
                            <Checkbox 
                                inputProps={{
                                }} 
                                checked={isOptional} 
                                onChange={e => {
                                    setOptional(e.target.checked)
                                }}  
                                name={"optional"} 
                                color="primary"
                            />
                        }
                        label="Optional"
                    />
                    {/* <Controller
                        name="continueontimeout"
                        control={control}
                        render={({ field, onChange, value }) =>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        {...field}
                                        onChange={e => {
                                            onChange(e.target.checked)
                                            setOptional(e.target.checked)
                                        }}
                                        name="continueontimeout"
                                        id="continueontimeout"
                                        color="primary"
                                        value={value}
                                        checked={value}
                                    />
                                }
                                label="ContinueOnTimeout"
                            />
                        }
                    /> */}
                    <FormControlLabel className="autoFill"
                            control={
                                <Checkbox 
                                    inputProps={{
                                    }} 
                                    checked={isContinueTimeout} 
                                    onChange={e => {
                                        setContinueTimeout(e.target.checked)
                                    }}  
                                    name={"continueontimeout"} 
                                    color="primary"
                                />
                            }
                            label="ContinueOnTimeout"
                        />
                    {/* <Controller
                        name="scatter_inst"
                        control={control}
                        render={({ field, onChange, value }) =>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        {...field}
                                        onChange={e => {
                                            onChange(e.target.checked)
                                            setOptional(e.target.checked)
                                        }}
                                        name="scatter_inst"
                                        id="optioscatter_instnal"
                                        color="primary"
                                        value={value}
                                        checked={value}
                                    />
                                }
                                label="ScatterInst"
                            />
                        }
                    /> */}
                    <FormControlLabel className="autoFill"
                            control={
                                <Checkbox 
                                    inputProps={{
                                    }} 
                                    checked={isScatterInst} 
                                    onChange={e => {
                                        setScatterInst(e.target.checked)
                                    }}  
                                    name={"scatter_inst"} 
                                    color="primary"
                                />
                            }
                            label="ScatterInst"
                        />

                </Grid>}


                {getConstructType(element.type) !== 'nested_transaction' && <>

                    <Grid item xs={6}>
                    <TextField
                        name="timeout"
                        fullWidth
                        type={"text"}
                        label={"Timeout"}
                        variant="outlined"
                        placeholder={"In milliseconds"}
                        error={errors?.timeout ? true : false}
                        inputRef={register({...wholeNumber})}
                        helperText={errors?.timeout && errors?.timeout?.message ? errors.timeout.message : ''}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Autocomplete
                            value={onErrorValue}
                            onChange={(event, newValue) => {
                                if (typeof newValue === 'string') {
                                    // User directly typed and hit enter
                                    const duplicateFunction = utilityFunctions.find(item => item.title === newValue);
                                    if (duplicateFunction) {
                                        setOnErrorValue(duplicateFunction);
                                    } else {
                                        handleCreateFunction(newValue);
                                    }
                                } else if (newValue && newValue.inputValue) {
                                     // User selected "Create new function ..."
                                     handleCreateFunction(newValue.inputValue);
                                } else {
                                    // User selected from list
                                    setOnErrorValue(newValue);
                                }
                            }}
                            filterOptions={(options, params) => {
                                const filtered = filter(options, params);
                                if (params.inputValue !== '' && !filtered.some(item => item.title === params.inputValue)) {
                                    filtered.unshift({
                                        inputValue: params.inputValue,
                                        title: `Create new utility function '${params.inputValue}'`,
                                    });
                                }
                                return filtered;
                            }}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            id="onerror"
                            options={utilityFunctions}
                            getOptionLabel={(option) => {
                                if (typeof option === 'string') {
                                return option;
                                }
                                if (option.inputValue) {
                                return option.inputValue;
                                }
                                return option.title;
                            }}
                            renderOption={(option) => option.title}
                            freeSolo
                            renderInput={(params) => (
                                <TextField 
                                {...params} 
                                InputLabelProps={{ shrink: true }}
                                name="onerror"
                                label="Error Callback Function"
                                variant="outlined"
                                fullWidth
                                placeholder={utilityFunctions.length === 0 ? "No functions found. Type to create one" : "Specify the function name"}
                                error={Boolean(errors?.onerror)}
                                helperText={
                                    errors?.onerror?.message ? errors?.onerror?.message : ""
                                }
                                inputRef={register({ required: false })}
                                />
                            )}
                            />
                </Grid>

                
                <Grid item xs={6}>
                    <TextField
                        name="spec"
                        fullWidth
                        type={"text"}
                        label={"Specification"}
                        variant="outlined"
                        placeholder={""}
                        inputRef={register({ required: false })}
                    />
                </Grid>


                <Grid item xs={3}>
                    <TextField
                        name="version"
                        fullWidth
                        type={"text"}
                        label={"Version"}
                        variant="outlined"
                        placeholder={""}
                        inputRef={register({ required: false })}
                    />
                </Grid>

                <Grid item xs={3}>
                    <TextField
                        name="section"
                        fullWidth
                        type={"text"}
                        label={"Section"}
                        variant="outlined"
                        placeholder={""}
                        inputRef={register({ required: false })}
                    />
                </Grid>
                 
                </>}

                {/* Update and cancel buttons */}
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                    <UpdateCancel onUpdate={handleSubmit(onUpdate)} onCancel={onCancel} updateDisable={isEditing || isLoading} content={isEditing ? 'Updating..' : isLoading ? 'Loading...' : 'Update'} />
                </Grid>

            </Grid>}

            {openUtilityFunctionDialog && <UtilityFunctionDialog handleClose={handleCloseUtilityFunctonDialog} setSelectedUtilityFunction={setSelectedUtilityFunction} selectedUtilityFunction={selectedUtilityFunction}/>}

        </>
    )
}